export default __webpack_public_path__ + "static/media/flag-vatican-city.1700c078.svg";